var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-upload",
    {
      ref: "uploader",
      staticClass: "upload-demo",
      attrs: {
        disabled: _vm.disabled,
        headers: _vm.myHeaders,
        limit: _vm.limit,
        accept: _vm.accept,
        "on-success": _vm.uploadSuccess,
        "before-upload": _vm.beforeUpload,
        "before-remove": _vm.beforeRemove,
        "on-remove": _vm.removeFile,
        "on-exceed": _vm.overSize,
        "auto-upload": _vm.autoUpload,
        "show-file-list": _vm.showFileList,
        "file-list": _vm.fileList,
        "list-type": _vm.listType,
        drag: _vm.drag,
        multiple: _vm.multiple,
        action: _vm.avatarUploadUrl,
      },
      on: { change: _vm.filterChange, "on-change": _vm.filterChange },
    },
    [
      _vm.drag
        ? [
            _c("i", { staticClass: "el-icon-upload" }),
            _vm._v(" "),
            _c("div", { staticClass: "el-upload__text" }, [
              _vm._v("将文件拖到此处，或"),
              _c("em", [_vm._v("点击上传")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                slot: "tip",
              },
              [_vm._v(_vm._s(_vm.noticeText))]
            ),
          ]
        : [
            _c("el-button", { attrs: { size: "small", type: "primary" } }, [
              _vm._v("点击上传"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                slot: "tip",
              },
              [_vm._v(_vm._s(_vm.noticeText))]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload/clickUpload.vue?vue&type=template&id=3ee309aa&
// module id = null
// module chunks = 